import { alpha } from "@mui/material/styles";
import { colors } from "../../theme/colors";

const INPUT_ACTIVE_BORDER = alpha(colors.primary.main, 0.55);
const INPUT_ACTIVE_RING = `0 0 0 3px ${alpha(colors.primary.main, 0.1)}`;

const READ_ONLY_FIELDSET_SX = {
    boxShadow: "none",
    "& fieldset": {
        borderColor: colors.border.default,
        borderWidth: "1px",
    },
};

export const OUTLINED_INPUT_SX = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
        backgroundColor: colors.background.surface,
        borderRadius: "10px",
        transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        "& fieldset": {
            borderColor: colors.border.default,
            borderWidth: "1px",
        },
        "&:hover": {
            boxShadow: INPUT_ACTIVE_RING,
            "& fieldset": {
                borderColor: INPUT_ACTIVE_BORDER,
            },
        },
        "&.Mui-focused": {
            boxShadow: INPUT_ACTIVE_RING,
            "& fieldset": {
                borderColor: INPUT_ACTIVE_BORDER,
                borderWidth: "1px",
            },
        },
        "&.Mui-readOnly": READ_ONLY_FIELDSET_SX,
        "&.Mui-readOnly:hover": READ_ONLY_FIELDSET_SX,
        "&.Mui-readOnly.Mui-focused": READ_ONLY_FIELDSET_SX,
        "&.Mui-error fieldset": {
            borderColor: `${colors.state.danger.main} !important`,
            borderWidth: "1px",
        },
        "&.Mui-error:hover": {
            boxShadow: `0 0 0 3px ${alpha(colors.state.danger.main, 0.12)}`,
            "& fieldset": {
                borderColor: `${colors.state.danger.main} !important`,
            },
        },
        "&.Mui-error.Mui-focused": {
            boxShadow: `0 0 0 3px ${alpha(colors.state.danger.main, 0.12)}`,
            "& fieldset": {
                borderColor: `${colors.state.danger.main} !important`,
                borderWidth: "1px",
            },
        },
        "&.Mui-disabled": READ_ONLY_FIELDSET_SX,
        "&.Mui-disabled:hover": READ_ONLY_FIELDSET_SX,
    },
    "& .MuiOutlinedInput-input": {
        color: colors.text.primary,
        fontSize: { xs: "0.82rem", xl: "0.92rem" },
        padding: "0.55rem 0.75rem",
        letterSpacing: "0.4px",
        "&::placeholder": {
            color: colors.text.muted,
            opacity: 1,
        },
        "&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active": {
            WebkitTextFillColor: `${colors.text.primary} !important`,
            caretColor: colors.text.primary,
            transition: "background-color 99999s ease-out 0s",
            boxShadow: `0 0 0 1000px ${colors.background.surface} inset`,
            WebkitBoxShadow: `0 0 0 1000px ${colors.background.surface} inset`,
        },
    },
};
